import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { AccordionContext } from '../context/AccordionContext';
import { createItemId } from '../helpers/generateId';
let counter = 0;
export const Item = ({ isOpen, toggle, children }) => {
    const id = useMemo(() => {
        counter += 1;
        return createItemId(String(counter));
    }, []);
    return (_jsx(AccordionContext.Provider, { value: { id, isOpen, toggle }, children: children }));
};
